import SigninComp from "../components/SigninComs/SigninComp";

const SigninPage = () => {
  return <SigninComp />;
};

export default SigninPage;
